import axios from 'axios';
import store from "../redux/store";
import {baseUrl} from "./network";

export const getTasksData = () => {
    const {tgUser} = store.getState().user;
    const headers = {
        'Content-Type': 'application/json',
    }
    return axios.get(`${baseUrl}/tasks/list?user_tg_id=${tgUser?.id}`, {headers})
        .then((res) => res)
}

export const sendModalData = (data) => {
    const {tgUser} = store.getState().user;
    const headers = {
        'Content-Type': 'multipart/form-data',
    }

    let formData = new FormData();

    formData.append('user_tg_id', tgUser?.id);
    formData.append('task_id', data?.task_id);
    formData.append('img', data?.img);
    formData.append('link', data?.link);

    return axios.post(`${baseUrl}/tasks/submit-modal`, formData, {headers})
        .then((res) => res)
}
